import { render, staticRenderFns } from "./AppAffiliateTemplates.vue?vue&type=template&id=35fdbbd7"
import script from "./AppAffiliateTemplates.vue?vue&type=script&lang=ts"
export * from "./AppAffiliateTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports